import { notifications } from "@mantine/notifications"
import { UseMutationOptions, useMutation } from "@tanstack/react-query"
import { AxiosError } from "axios"

import { RunLcaOnProducts } from "@tfg/types/schemas/modules/lifeCycleAnalysis/queries/run-lca-on-products"

import { httpClient } from "~/backend/axios.ts"
import { queryClient } from "~/backend/queryClient.ts"

export const useRunLcaOnProductsMutation = (
  options?: UseMutationOptions<unknown, AxiosError, RunLcaOnProducts>
) => {
  return useMutation({
    ...options,
    mutationFn: async (body: RunLcaOnProducts) => {
      return await httpClient.put("/lca/run-lca-on-products", body)
    },
    onSuccess: (data, variables, context) => {
      options?.onSuccess?.(data, variables, context)
      queryClient.invalidateQueries(["products", "lca"])
    },
    onError: (error, variables, context) => {
      options?.onError?.(error, variables, context)
      notifications.show({
        title: "Error",
        message: error.message,
        color: "red",
      })
    },
  })
}
